import $ from 'jquery';
import _ from 'ext:lodash';
import Framework from 'framework';
import clubStore from 'framework/stores/ClubStore';
import nearestClubStore from 'framework/stores/nearestClubStore';
import profileStore from 'framework/stores/ProfileStore';
import UrlUtils from 'lib/url-utils';
import MobileUtils from 'lib/mobile-utils';
import MapUtils from 'lib/map-utils';
import locationService from 'framework/services/locationService';
import constants from 'lib/constants';
import locationSharingTracking from 'lib/location-sharing-tracking';

export default class LocateAClub {

	constructor(el, config, Omnibox, referralCode, referralSource, promotionName, utmData, altExp, defaultProperties, authoredProperties) {
		this.el = el;
		this.config = config;
		this.Omnibox = Omnibox;
		this.clubStore = clubStore;
		this.nearestClubStore = nearestClubStore;
		this.profileStore = profileStore;
		this.referralCode = referralCode;
		this.referralSource = referralSource;
		this.promotionName = promotionName;
		this.utmData = utmData;
		this.altExp = altExp;
		this.defaultProperties = defaultProperties;
		this.authoredProperties = authoredProperties;

		this.state = {
			currentTextQuery: '',
			currentQuery: null,
			lastQuery: null,
			searchResults: [],
			clubsDisplayedOnMap: [],
			filteredResults: [],
			searchDistance: 3600,
			programFilters: [],
			serviceFilters: [],
			featureFilters: [],
			defaultFilter: true,
			mapCenter: null,
			clubMarkers: [],
			directionsURL: config.directionsURL,
			queryParam: '',
			memberState: '',
			memberDetails: {},
			accessClubs: [],
			experienceType: 'member',
			userLocation: null,
			bounds: null,
			stateSearch: false,
			searchCount: 0,
			searchSource: ''
		};
	}

	setState(newState) {
		_.assign(this.state, newState);
		this.state.filteredResults = this.filterResults(this.state.searchResults);
		this.adjustMap();
		this.renderResults();
		this.sendAnalyticsData();
	}

	checkParams() {
		// grab all URL paramters
		var params = UrlUtils.getAllUrlParameters();

		// check for filter params in the list and add them to state arrays and trigger checkbox behavior
		if(params.program) {
			_.forEach(params.program, (v) => {
				this.state.programFilters.push(v);
				$('#program-filter input[value="' + v + '"]').attr('checked', true).trigger('change');
			});
		}
		if(params.service) {
			_.forEach(params.service, (v) => {
				this.state.serviceFilters.push(v);
				$('#service-filter input[value="' + v + '"]').attr('checked', true).trigger('change');
			});
		}
		if(params.feature) {
			_.forEach(params.feature, (v) => {
				this.state.featureFilters.push(v);
				$('#feature-filter input[value="' + v + '"]').attr('checked', true).trigger('change');
			});
		}
		if(params.clubAccess) {
			this.handleAccessFilter();
		}
	}

	initialize(initialVal, map) {
		this.map = map;
		this.results = $(this.config.results);
		this.state.experienceType = Framework.global.lt.pageProperties.experienceType;
		if(this.state.experienceType === constants.experienceTypeMember) {
			$('.main-mylt').addClass('club-locate-member');
		}

		// element variables for functionality that adds classes when showing filters/chiclets
		var filterWrap = $('.club-locate .map-filters');
		var filterPanels = filterWrap.find('.collapse');
		var wrapClose = true;
		// bind events for css class additions based on filter/chiclet visibility
		filterPanels.on('show.bs.collapse', function(e){
			if(wrapClose) {
				filterWrap.addClass('active open');
				wrapClose = false;
			}
		});
		filterPanels.on('hide.bs.collapse', function(e){
			// if only one panel is left open, close the wrapper
			if(filterPanels.filter('.in').length === 1) {
				filterWrap.removeClass('open');
				wrapClose = true;
			}
		});
		filterPanels.on('hidden.bs.collapse', function(e){
			if(wrapClose) {
				filterWrap.removeClass('active');
			}
		});

		$('body').on('keydown', this.config.resultsList, function(e) {
			if(e.which === 13) {
				$(this).trigger('click');
			}
			if(e.which === 40) {
				e.preventDefault();
				$(this).next().focus();
			}
			if(e.which === 38) {
				e.preventDefault();
				$(this).prev().focus();
			}
		});

		// listen for nearestClubStore update and use results
		this.nearestClubStore.listen(this.handleClubResults.bind(this));

		// determine initial club results
		if(initialVal) {
			// if the query parameter is present due to omnibox use off-page use it to find results
			this.state.currentQuery = this.state.currentTextQuery = initialVal;

			//get nearestClubStore initial data
			let nearestData = this.nearestClubStore.getInitialData();
			if(!nearestData.pending && nearestData.clubs.length > 0) {
				// populate results using nearestClubStore data
				this.handleClubResults(nearestData);
			}
		} else{
			var self = this;
			this.map.api.event.addListenerOnce(this.map.map, 'idle', function() {
				// do something only the first time the map is loaded
				// grab user location
				self.getUserLocation();
			});
		}

		// grab profile info for club access information
		let profileData = this.profileStore.getInitialData();

		// check profile data status
		if(profileData.memberState !== 'UNKNOWN') {
			// capture memberState
			this.state.memberState = profileData.memberState;
			if(profileData.memberDetails !== null) {
				this.state.memberDetails = profileData.memberDetails;
			}
		} else{
			var unsubToProfileStore = this.profileStore.listen((profile) => {
				this.state.memberState = profile.memberState;
				if(profile.memberDetails !== null) {
					this.state.memberDetails = profile.memberDetails;
				}
				if(window.location.search.indexOf('clubAccess') > -1){
					this.handleAccessFilter();
				}
				unsubToProfileStore();
			});
		}

		// create omnibox
		this.omnibox = new this.Omnibox(this.el);

		this.omnibox.initialize({
			queryLimit: 200,
			distance: this.state.searchDistance,
			onSearch: this.setSearchQuery.bind(this),
			initialVal: initialVal,
			type: constants.clubSearchSource.omniboxFindAClub
		});

		// bind filter handler function to all filter input fields
		this.$filterInput = $(this.config.filterInput);
		this.$filterInput.on('change', (event) => {
			this.newSearchEvent(constants.clubSearchSource.filterApply);
			this.handleFilterClick(event);
		});

		// listen for map drag event and determine if new results should be displayed
		$(document).on('lac-dragged', ()=> {
			this.newSearchEvent(constants.clubSearchSource.mapDrag);
			this.newBoundsRequest();
			this.sendAnalyticsData();
		});

		$(document).on('zoom-changed', ()=> {
			this.newBoundsRequest();
		});

		// bind expand and contract behavior to show and hide links
		$('.show-btn').on('click', (event)=> {
			if(event.target.className.indexOf('collapsed') > -1) {
				$(event.target).closest('.column-item').addClass('expanded');
				$(event.target).find('span').removeClass('ico-plus-sm').addClass('ico-minus-sm');
			} else{
				$(event.target).closest('.column-item').removeClass('expanded');
				$(event.target).find('span').removeClass('ico-minus-sm').addClass('ico-plus-sm');
			}
		});

		// clicks on chiclets will uncheck the appropriate filter and trigger change behavior
		$('.chiclets-container').on('click', '.chiclet', function(){
			var filter = $(this).data('filter');
			$('#filterControls input#' + filter).attr('checked', false).trigger('change');
		});

		if(window.location.search.length > 0){
			this.checkParams();
		}
	}

	newSearchEvent(searchSource) {
		this.state.searchCount += 1;
		this.state.searchSource = searchSource;
	}

	getUserLocation() {
		var self = this;
		var userLocation = null;
		// init SDI location sharing tracking WEB-16271
		locationSharingTracking();
		// call location service
		locationService.api.get().then(
			//Success - trigger change in data
			(data)=> {
				if(data.coordinate) {
					userLocation = data.coordinate;
					this.getClubsFromUserLocation(userLocation, constants.clubSearchSource.lowAccuracySearch);
				}
				if(navigator.geolocation) {
					// set new center based on user's geolocation
					navigator.geolocation.getCurrentPosition(function (position) {
						// if the search field has been touched, do not run the search based on high-accuracy
						if(!$('label[for="locationInput"]').hasClass('has-focus')) {
							userLocation = {latitude: position.coords.latitude, longitude: position.coords.longitude};
							self.getClubsFromUserLocation(userLocation, constants.clubSearchSource.locationSharing);
						}
					});
				}
			},
			//Error - log error
			(message)=> {
				if(navigator.geolocation) {
					// if the search field has been touched, do not run the search based on high-accuracy
					if(!$('label[for="locationInput"]').hasClass('has-focus')) {
						// set new center based on user's geolocation
						navigator.geolocation.getCurrentPosition(function (position) {
							userLocation = {latitude: position.coords.latitude, longitude: position.coords.longitude};
							self.getClubsFromUserLocation(userLocation, constants.clubSearchSource.locationSharing);
						});
					}
				}
			}
		);
	}

	getClubsFromUserLocation(userLocation, searchSource){
		this.state.userLocation = userLocation;
		this.state.mapCenter = {lat: userLocation.latitude, lng: userLocation.longitude};
		this.map.setState({
			mapCenter: this.state.mapCenter,
			userLocation: this.state.userLocation
		});
		if(this.state.userLocation && this.state.userLocation.latitude){
			let coordsObj = {
				latitude: this.state.userLocation.latitude,
				longitude: this.state.userLocation.longitude
			};
			Framework.actions.searchForNearestClub(coordsObj, this.config.queryLimit, this.state.searchDistance, searchSource);
		}
	}

	handleSearchResults(searchResults) {
		if(searchResults.query === this.state.currentQuery && !searchResults.pending) {

			if(searchResults.invalid) {
				this.omnibox.setSearchInvalid();
			} else{
				this.omnibox.setSearchValid();
				var mapCenter = {
					lat: searchResults.projectedQuery.latitude,
					lng: searchResults.projectedQuery.longitude
				};
			}

			this.setState({
				lastQuery: searchResults.query,
				lastQueryText: this.state.currentTextQuery,
				searchDistance: searchResults.projectedQuery.distance,
				mapCenter: mapCenter,
				searchResults: searchResults.clubs
			});
			$('#locationInput').trigger('change');
		}
	}

	handleClubResults(searchResults) {
		var mapCenter = {};
		var bounds = {};
		this.newSearchEvent(searchResults.searchSource);
		if(!searchResults.pending && searchResults.clubs.length > 0){
			mapCenter = {
				lat: searchResults.projectedQuery.latitude,
				lng: searchResults.projectedQuery.longitude
			};
			// determine if state search and set map bounds
			if(searchResults.bounds.sw && searchResults.bounds.ne && !searchResults.stateSearch) {
				const { latitude: swLat, longitude : swLong } = searchResults.bounds.sw;
				const { latitude: neLat, longitude : neLong } = searchResults.bounds.ne;

				if (swLat && swLong && neLat && neLong) {
					const sw = new this.map.api.LatLng(swLat, swLong);
					const ne = new this.map.api.LatLng(neLat, neLong);
					bounds = new this.map.api.LatLngBounds(sw, ne);
				} else {
					bounds = null;
				}
			} else {
				bounds = null;
			}
			this.setState({
				lastQuery: searchResults.query,
				lastQueryText: this.state.currentTextQuery,
				searchDistance: searchResults.projectedQuery.distance,
				searchResults: searchResults.clubs,
				mapCenter: mapCenter,
				userLocation: {
					latitude: mapCenter.lat,
					longitude: mapCenter.lng
				},
				bounds: bounds,
				stateSearch: searchResults.stateSearch
			});
		} else if(!searchResults.pending && !searchResults.clubs.length > 0) {
			mapCenter = {
				lat: searchResults.projectedQuery.latitude,
				lng: searchResults.projectedQuery.longitude
			};
			this.setState({
				lastQuery: searchResults.query,
				lastQueryText: this.state.currentTextQuery,
				searchDistance: searchResults.projectedQuery.distance,
				searchResults: searchResults.clubs,
				mapCenter: mapCenter,
				userLocation: {
					latitude: mapCenter.lat,
					longitude: mapCenter.lng
				}
			});
		}
	}

	handleFilterClick(evt) {
		if(evt && evt.preventDefault && typeof evt.preventDefault === 'function') {
			evt.preventDefault();
		}

		var filter = evt;

		if(filter.currentTarget.id.indexOf('program') > -1) {
			var pFilters = [];
			$('#program-filter input:checked').each(function(){
				pFilters.push($(this).val());
			});

			this.handleChiclet(filter);

			this.setState({
				programFilters: pFilters,
				defaultFilter: false
			});
		}

		if(filter.currentTarget.id.indexOf('service') > -1) {
			var sFilters = [];
			$('#service-filter input:checked').each(function(){
				sFilters.push($(this).val());
			});

			this.handleChiclet(filter);

			this.setState({
				serviceFilters: sFilters,
				defaultFilter: false
			});
		}

		if(filter.currentTarget.id.indexOf('feature') > -1) {
			var fFilters = [];
			$('#feature-filter input[id^="feature"]:checked').each(function(){
				fFilters.push($(this).val());
			});

			this.handleChiclet(filter);

			this.setState({
				featureFilters: fFilters,
				defaultFilter: false
			});
		}

		if(filter.currentTarget.id.indexOf('clubAccess') > -1) {
			this.handleAccessFilter(filter);
		}

		if(!this.state.defaultFilter){
			var filterParams = [];
			filterParams[0] = '';
			filterParams[1] = false;
			if(Framework.global.location.search.indexOf('query') > -1 && this.state.queryParam === ''){
				this.state.queryParam = UrlUtils.getUrlParameter('query');
			}
			if(this.state.programFilters.length){
				filterParams = UrlUtils.handleParams(this.state.programFilters, 'program', filterParams, 'query', this.state.queryParam);
			}
			if(this.state.serviceFilters.length){
				filterParams = UrlUtils.handleParams(this.state.serviceFilters, 'service', filterParams, 'query', this.state.queryParam);
			}
			if(this.state.featureFilters.length){
				filterParams = UrlUtils.handleParams(this.state.featureFilters, 'feature', filterParams, 'query', this.state.queryParam);
			}
			if(filter.currentTarget.id.indexOf('clubAccess') > -1 && filter.currentTarget.checked) {
				filterParams = UrlUtils.handleParams(['true'], 'clubAccess', filterParams, 'query', this.state.queryParam);
			}

			Framework.actions.updateUrl(Framework.global.location.pathname + filterParams[0]);
		}
	}

	handleAccessFilter(filter) {
		if(filter){
			if(filter.currentTarget.checked){
				if(this.state.memberState === 'UNAUTHENTICATED'){
					Framework.actions.createInfoNotification('<strong>You must log in to apply this filter.</strong> <a href="' + Framework.global.lt.globalPageDrivers.global.loginResource + '">Log in</a>');
					filter.currentTarget.checked = false;
				} else{
					if(!$.isEmptyObject(this.state.memberDetails) && this.state.memberDetails.availableClubs){
						this.setState({
							accessClubs: this.state.memberDetails.availableClubs,
							defaultFilter: false
						});
					} else{
						this.setState({
							accessClubs: ['no-match'],
							defaultFilter: false
						});
					}
				}
			} else{
				this.setState({
					accessClubs: [],
					defaultFilter: false
				});
			}

			this.handleChiclet(filter);
		} else{
			$('.chiclets-container .chiclet[data-filter="clubAccess"]').remove();
			$('#clubAccess').attr('checked', true).trigger('change');
		}
	}

	handleChiclet(evt) {
		if(evt.target.checked){
			var chicletLabel = $(evt.target).attr('data-label');
			// construct chiclet template
			var chiclet = `
				<button class="chiclet" data-filter="${evt.target.id}">
					<span class="sr-only">Remove </span>
					${chicletLabel}
					<span class="sr-only">” Filter</span>
					<span class="chiclet-close"></span>
				</div>
			`;
			// add chiclet
			$('.chiclets-container').append(chiclet);
			// show chiclet div
			$('#resultChiclets').collapse('show');
		} else{
			var chicletSelect = '.chiclet[data-filter="' + evt.target.id + '"]';
			$(chicletSelect).remove();
			// check to see if all chiclets have been removed and close div
			if($('.chiclets-container button').length <= 0) {
				$('#resultChiclets').collapse('hide');
			}
		}
	}

	filterResults(results) {
		var programFilter = this.state.programFilters;
		var serviceFilter = this.state.serviceFilters;
		var featureFilter = this.state.featureFilters;
		var clubAccessFilter = this.state.accessClubs;

		var filteredClubs = _.filter(results, function(c) {
			return c;
		});

		// Filter out clubs with hideFromPublicView is true
		filteredClubs = filteredClubs.filter((c) => c.hideFromPublicView !== true);

		if(clubAccessFilter !== null && clubAccessFilter.length !== null) {
			if(clubAccessFilter.length > 0){
				filteredClubs = _.filter(filteredClubs, function(c) {
					// go over available clubs list and return any clubs that match
					return _.includes(clubAccessFilter, c.mmsClubId);
				});
			}
		}

		// check if any program filters are selected
		if(programFilter.length > 0) {
			// filter on filteredClubs which currently holds all club objects within specified distance
			filteredClubs = _.filter(filteredClubs, function(c) {
				// make sure club has programs sub-object
				if(c.programs == null) {
					return false;
				}

				if(c.programs.length) {
					// go over each selected filter and return any clubs that match
					return _.every(programFilter, function(filter) {
						return _.some(c.programs, function(program) {
							return program.id === filter;
						});
					});
				} else{
					return false;
				}
			});
		}

		// check if any service filters are selected
		if(serviceFilter.length > 0) {
			filteredClubs = _.filter(filteredClubs, function(c) {
				// make sure club has services sub-object
				if(c.services == null) {
					return false;
				}

				if(c.services.length) {
					// go over each selected filter and return any clubs that match
					return _.every(serviceFilter, function(filter) {
						return _.some(c.services, function(service) {
							return service.id === filter;
						});
					});
				} else{
					return false;
				}
			});
		}

		// check if any feature filters are selected
		if(featureFilter.length > 0) {
			filteredClubs = _.filter(filteredClubs, function(c) {
				// make sure club has programs sub-object
				if(c.features == null) {
					return false;
				}

				if(c.features.length) {
					// go over each selected filter and return any clubs that match
					return _.every(featureFilter, function(filter) {
						return _.some(c.features, function(feature) {
							return feature.id === filter;
						});
					});
				} else{
					return false;
				}
			});
		}

		if(!filteredClubs.length && this.state.defaultFilter === true) {
			return results;
		}

		return filteredClubs;
	}

	renderResults() {
		// reset results panel
		$(this.config.resultsNone).hide();
		$(this.config.resultsListContainer).empty();
		$(this.config.resultsListContainer).show();

		// take filtered results and render them
		this.state.clubsDisplayedOnMap = [];
		_.map(this.state.filteredResults, this.renderResult.bind(this));

		// determine if we need to show failure to locate clubs in map/filter states
		if(!$(this.config.resultsList).length || !this.state.filteredResults.length) {
			$(this.config.resultsCountNum).text('0');
			if(this.state.programFilters.length || this.state.serviceFilters.length || this.state.featureFilters.length || this.state.accessClubs.length) {
				// display no results with filter
				$(this.config.resultsListContainer).hide();
				$(this.config.resultsNoneFilter).show();
			} else{
				// display no results nearby
				$(this.config.resultsListContainer).hide();
				$(this.config.resultsNoneNearby).show();
			}
		} else{
			$(this.config.resultsCountNum).text($(this.config.resultsList).length);
		}
		if($(this.config.locationInput).val() !== ''){
			$(this.config.resultsCountStr).text($(this.config.locationInput).val());
		} else{
			$(this.config.resultsCountStr).text('your location.');
		}
		this.map.triggerResize();
	}

	mergeProperties(obj, defaultObj) {
		let returnObj = Object.assign({}, defaultObj)
		Object.keys(obj).forEach(function (key) {
			if (!!obj[key]) {
				returnObj[key] = obj[key];
			}
		})
		return returnObj;
	}

	renderResult(club) {
		let properties = this.authoredProperties[club.mmsClubId] ?
			this.mergeProperties(this.authoredProperties[club.mmsClubId], this.defaultProperties) : this.defaultProperties;
		let clubPosition = new this.map.api.LatLng(club.latitude, club.longitude);
		if(this.map.map.getBounds().contains(clubPosition)){
			this.state.clubsDisplayedOnMap.push(club);
			var clubLinks = '';
			var clubType = '';
			var omsPrice = '';
			var clubStreetTwo = '';
			var comingSoonTemplate = '';
			var directionsEl = '';
			var coordinatesTemplate = '';

			// create directions link
			if(MobileUtils.getMobileDeviceType() === 'windows'){
				coordinatesTemplate = `${club.latitude}_${club.longitude}`;
			} else{
				coordinatesTemplate = `${club.latitude},${club.longitude}`;
			}

			let dirUrl = MobileUtils.getDirectionsBaseUrl();

			directionsEl = `
				<span class="hidden-lg-up"><a href="${dirUrl}${coordinatesTemplate}">Directions</a></span>
			`;

			// define street2 template if applicable
			if(club.street2) {
				clubStreetTwo = `${club.street2}<br>`;
			}

			// define coming soon messaging template if applicable
			if(club.comingSoon && (club.open === 'waitlist' || club.open === 'presale')) {
				comingSoonTemplate = `<p class="coming-soon h-th">${club.comingSoon}</p>`;
			}

			// define club type template
			// check if is a lt club or lt athletic club
            const ltClubType = club.clubTypeId === 1 || club.clubTypeId === 2;
			if(!ltClubType) {
				clubType = `
					<p class="m-b-0">${club.membershipLevel}</p>
				`;
			}

			const detailsCtaText = ltClubType ? properties['clubDetailsCtaText'] : properties['nonClubDetailsCtaText'];
			if(this.state.experienceType === constants.experienceTypeProspect) {

				/* eslint-disable func-style */
				const buildJoinLink = (href) => {
					const prefix = `<a class="btn btn-primary btn-xs m-l-sm m-b-sm pull-xs-right" aria-describedby="club${club.mmsClubId}" data-club="${club.mmsClubId}" href="`;
					const joinBtnName = club.open === 'waitlist'
						? properties.waitlistCtaText
						: properties.joinCtaText;
					const suffix = `" onclick="event.preventDefault(); window.ef.prospectProfileStore.updateProspectClub(event.target.dataset.club).then(() => { window.location.href = event.target.href; });">${joinBtnName}</a>`;

					return `${prefix}${href}${suffix}`;
				};
				/* eslint-enable func-style */

				if(club.oms === 'Yes') {
					// create initial oms join link url
					var joinUrl = Framework.global.lt.globalPageDrivers.global.transition + '?clubId=' + club.mmsClubId;
					var altExpJoinUrl = Framework.global.lt.globalPageDrivers.global.addMembers + '?clubId=' + club.mmsClubId;

					// update url if we have referral information to pass
					if(this.referralCode) {
						joinUrl += '&source=' + this.referralSource + '&referral=' + encodeURIComponent(this.referralCode);
						altExpJoinUrl += '&source=' + this.referralSource + '&referral=' + encodeURIComponent(this.referralCode);
					}

					// update url if we have promotion information to pass
					if(this.promotionName) {
						joinUrl += '&promotionName=' + this.promotionName + '&source=web';
						altExpJoinUrl += '&promotionName=' + this.promotionName + '&source=web';
					}

					// update url if we have tracking information to pass
					if(this.utmData) {
						_.each(this.utmData, (value, param)=> {
							joinUrl += '&' + param + '=' + value;
							altExpJoinUrl += '&source=' + this.referralSource + '&referral=' + encodeURIComponent(this.referralCode);
						});
					}

					// if we are using the alternative experience flow to OMS, switch the destination url variables
					if((this.altExp && this.promotionName !== 'lta') && (this.altExp && this.promotionName !== 'yogateachertraining')) {
						if(ltClubType){
							clubLinks = buildJoinLink(altExpJoinUrl);
						}
						clubLinks += `<a class="btn btn-link btn-xs m-b-sm p-x-0 b-x-xs-0 pull-xs-right" aria-describedby="club${club.mmsClubId}" href="${club.prospectPagePath}">${detailsCtaText}</a>`;
					} else{
						if(ltClubType){
							clubLinks = buildJoinLink(joinUrl);
						}
						clubLinks += `<a class="btn btn-link btn-xs m-b-sm p-x-0 b-x-xs-0 pull-xs-right" aria-describedby="club${club.mmsClubId}" href="${club.prospectPagePath}">${detailsCtaText}</a>`;
					}

					if(!this.altExp) {
						omsPrice = `
							<p class="m-b-0" data-oms data-oms-club="${club.mmsClubId}"></p>
						`;
					}
				} else if(club.prospectLink) {
					if(ltClubType){
						clubLinks = buildJoinLink(club.prospectLink);
					}
					clubLinks += `<a class="btn btn-link btn-xs m-b-sm p-x-0 b-x-xs-0 pull-xs-right" aria-describedby="club${club.mmsClubId}" href="${club.prospectPagePath}">${detailsCtaText}</a>`;
				} else{
					clubLinks = `
						<a class="btn btn-link btn-xs m-b-sm p-x-0 b-x-xs-0 pull-xs-right" aria-describedby="club${club.mmsClubId}" href="${club.prospectPagePath}">${detailsCtaText}</a>
					`;
				}
				// hide club type from prospects
				if(constants.clubType.club.indexOf(club.clubTypeId) > -1) {
					clubType = '';
				}
			} else{
				clubLinks = `
					<a class="btn btn-link btn-xs m-b-sm p-x-0 b-x-xs-0 pull-xs-right" aria-describedby="club${club.mmsClubId}" href="${club.clubPagePath}">${detailsCtaText}</a>
				`;
			}
			var cardTemplate = `
				<li id="card-${club.mmsClubId}" class="map-result b-b p-a-grid" tabindex="0" aria-label="${club.name}" aria-role="button">
					<div class="row">
						<div class="col-xs-8 col-lg-7">
							<div class="text-gray-4">
								${comingSoonTemplate}
								<p id="club${club.mmsClubId}"class="font-weight-bold m-b-0">${club.name}</p>
								<p class="m-b-0 small"><span class="font-weight-bold">${club.distance} mi</span> away ${directionsEl}</p>
							</div>
							<div class="small">
								${clubType}
								${omsPrice}
							</div>
						</div>
						<div class="col-xs-4 col-lg-5 edge-l-xs-up text-xs-right">
							${clubLinks}
						</div>
					</div>
				</li>
			`;

			$('.results-list').append(cardTemplate);
		}
	}

	setSearchQuery(data) {
		this.state.currentQuery = data.query;
		this.state.currentTextQuery = data.text;
	}

	adjustMap() {
		let mapCenter = this.state.mapCenter;

		this.map.setState({
			clubs: this.state.filteredResults,
			mapCenter: mapCenter,
			userLocation: this.state.userLocation,
			bounding: this.state.bounds,
			stateSearch: this.state.stateSearch
		});
		if(!this.state.stateSearch) {
			this.map.map.setZoom(MapUtils.getZoomLevel());
		}
	}

	newBoundsRequest(){
		this.state.mapCenter = {
			lat: this.map.map.getCenter().lat(),
			lng: this.map.map.getCenter().lng()
		};
		this.map.setState({
			mapCenter: this.state.mapCenter,
			bounding: null
		});
		this.renderResults();
	}

	sendAnalyticsData(){
		let resultsForAnalytics = this.state.clubsDisplayedOnMap.map((value, index) => {
			return {
				resultPosition: index + 1,
				resultItemStatus: [value.open, value.oms, value.webFreePass].join('::'),
				resultItemName: value.name,
				resultItemID: 'LL_' + value.mmsClubId,
				resultDistanceFromPOI: _.toString(value.distance)
			};
		});

		let accessClubsFilterValues = this.state.accessClubs.map(value => {
			return {
				'filterKey': 'clubAccess',
				'filterValue': value
			};
		});

		function getChicletFilterValues(filterKey, filters){
			return filters.map((value) => {
				return {
					'filterValue': $('#' + filterKey + '-filter input[value="' + value + '"]').data('label'),
					'filterKey': filterKey
				};
			});
		}
		let appliedFilters = accessClubsFilterValues
			.concat(getChicletFilterValues('program', this.state.programFilters))
			.concat(getChicletFilterValues('service', this.state.serviceFilters))
			.concat(getChicletFilterValues('feature', this.state.featureFilters));

		appliedFilters.forEach((value, index) => {
			_.extend(value, {'filterID': 'filter_' + (index + 1)});
		});

		Framework.actions.collectAnalytics({
			'locationSearch': {
				'searchResults': {
					'resultsCount': resultsForAnalytics.length,
					'resultItem': resultsForAnalytics
				},
				'searchParams': {
					'searchType': this.state.searchSource,
					'searchText': this.state.currentTextQuery,
					'searchPOILongitude': _.get(this.state, 'mapCenter.lng', ''),
					'searchPOILatitude': _.get(this.state, 'mapCenter.lat', ''),
					'searchMapZoom': _.get(this.map, 'map.zoom', ''),
					'searchCount': this.state.searchCount,
					'filtersApplied': appliedFilters,
					'filterState': $(this.config.toggleFilterControls).attr('aria-expanded') === 'true' ? 'shown' : 'hidden',
					'filterCount': appliedFilters.length
				}
			},
			'event': 'Locations Searched'
		});
	}
}
